import { Injectable } from '@angular/core';
import { UrlPartValidationResult} from '../models/url-part-validation-result.model';
@Injectable()
export class UrlPartValidatorService {

  constructor() { }
    public matchExpression : RegExp = /^[a-zA-Z0-9-_]$/;
    validate(prospect: string): UrlPartValidationResult {
        var result = new UrlPartValidationResult();
        if (!prospect) {
            result.invalidReasons.push("a value is required");
        } else {
            if (prospect.length < 3) {
                result.invalidReasons.push("the url part must be at least 3 characters long");
            }
            if (prospect.length > 20) {
                result.invalidReasons.push("the url part must be no more than 20 characters long");
            }
            if (!this.matchExpression.test(prospect)) {
                result.invalidReasons.push("the url");
            }
        }

        return result;
    }
}
